export const GAP = '16px'



// WEBPACK FOOTER //
// ./src/constants/spacing.js